import {
  CHECKOUT_RESET_STATE,
  CHECKOUT_RESET_TO_DEFAULT_STATE,
  SHOW_GIFT_CARD_MODAL,
  UPDATE_GIFT_CARD_CODE
} from 'constants/reduxActions';

const defaultState = {
  showModal: false,
  isLoading: false
};

export function giftCards(state = defaultState, action = {}) {
  const { giftCardCode, type, visible } = action;

  switch (type) {
    case CHECKOUT_RESET_STATE: {
      return { ...state, showModal: false, code: '' };
    }

    case SHOW_GIFT_CARD_MODAL: {
      return { ...state, showModal: visible };
    }

    case UPDATE_GIFT_CARD_CODE: {
      return { ...state, code: giftCardCode };
    }

    case CHECKOUT_RESET_TO_DEFAULT_STATE: {
      return defaultState;
    }

    default:
      return state;
  }
}
